import CryptoJS from 'crypto-js';
import Hashids from "hashids";


export const parseInstituteHash = (hash) => {
    let institute_id  =  hash - process.env.REACT_APP_URL_HASH_SALT
    return (
      institute_id
    );
}

export const makeInstituteHash = (institute_id) => {
    let hash  =  parseInt(institute_id) + parseInt(process.env.REACT_APP_URL_HASH_SALT)
    return (
      hash
    );
}

export const getInfra = () => {
  const baseUrl = window.location.origin;
  const host = new URL(baseUrl).hostname;
  const parts = host.split('.');

  
  let institute_hash = "";
  let infra = "";

  if (parts.length === 4 && parts[0].length === 10) {
    institute_hash = parts[0];
    infra = parts[1];
  } else if (parts.length === 4 && parts[0].length !== 10) {
    infra = parts[1];
  } else {
    infra = parts[0];
  }
  return { infra, institute_hash };
};


export const prepareAJAXData = (data) => {
    var ctObj = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_SECRET_KEY);
    return (
      { "data": ctObj.toString() }
    );
}
export  const maskNumber = (number) => {
  return '*'.repeat(number.length);
};

const maskEmail = (email) => {
    const [user, domain] = email.split('@');
    const maskedUser = '*'.repeat(user.length);
    return `${maskedUser}@${domain}`;
  };
  const maskPhoneNumber = (html) => {
    const phoneRegex = /\b\d{10}\b/g;
    return html.replace(phoneRegex, '**********');
  };

 export const maskEmailsInString = (inputString) => {
    var mobile_no_repalced=maskPhoneNumber(inputString)
    return mobile_no_repalced.replace(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g, (match) => {
      return maskEmail(match);
    });
  };
 
 

// Helper function to perform PKCS#7 padding
function pkcs7pad(data) {
    const blockSize = 16;
    // Convert to UTF-8 bytes to get actual byte length
    const utf8Bytes = new TextEncoder().encode(data);
    const padding = blockSize - (utf8Bytes.length % blockSize);
    const pad = String.fromCharCode(padding);
    return data + pad.repeat(padding);
}

// Helper function to remove PKCS#7 padding
function pkcs7unpad(data) {
    // Get the padding value from the last character
    const lastCharCode = data.charCodeAt(data.length - 1);
    // Validate that the padding value is reasonable (1-16 for PKCS#7)
    if (lastCharCode > 0 && lastCharCode <= 16) {
        // Check if all padding characters are the same
        const paddingCount = lastCharCode;
        let isValidPadding = true;
        for (let i = 1; i <= paddingCount; i++) {
            if (data.charCodeAt(data.length - i) !== lastCharCode) {
                isValidPadding = false;
                break;
            }
        }
        if (isValidPadding) {
            return data.slice(0, -paddingCount);
        }
    }
    // If padding is invalid, return data as-is (this handles edge cases)
    return data;
}

export const decryptData = (ciphertextHex) => {
    const key=process.env.REACT_APP_SECRET_KEY;
    const hash_skey = CryptoJS.MD5(key);
    const secret_key = CryptoJS.enc.Hex.parse(hash_skey.toString());

    // Initialization vector
    const init_vector = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

    // Convert ciphertext from hex to bytes
    const ciphertext = CryptoJS.enc.Hex.parse(ciphertextHex);

    // Perform decryption
    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: ciphertext },
        secret_key,
        {
            iv: init_vector,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.NoPadding,
        }
    );
    // Convert bytes back to string
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    // Remove PKCS#7 padding
    return pkcs7unpad(decryptedText);
}
 
export function encryptText(plainText) {
  if (typeof plainText !== 'string') {
    plainText = JSON.stringify(plainText);
  }

  const hashSkey = CryptoJS.MD5(process.env.REACT_APP_SECRET_KEY);
  const secretKey = CryptoJS.enc.Hex.parse(hashSkey.toString());
  const initVector = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

  const paddedText = pkcs7pad(plainText);
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(paddedText), secretKey, {
    iv: initVector,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding
  });

  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}


export function decodeId(hashid, salt = process.env.REACT_APP_SECRET_KEY, minLength = 10) {
  try {
    const hashids = new Hashids(
      salt,
      minLength,
      "abcdefghijklmnopqrstuvwxyz0123456789"
    );

    const decoded = hashids.decode(hashid);
    return decoded.length ? decoded[0] : "";
  } catch (e) {
    console.error("Error decoding ID:", e);
    return "";
  }
}

export function encodeId(
  id,
  salt = process.env.REACT_APP_SECRET_KEY,
  minLength = 10
) {
  try {
    if (id === null || id === undefined || id === "") return "";

    const hashids = new Hashids(
      salt,
      minLength,
      "abcdefghijklmnopqrstuvwxyz0123456789"
    );

    return hashids.encode(Number(id));
  } catch (e) {
    console.error("Error encoding ID:", e);
    return "";
  }
}

export function getLeadIdForCopy(candidate) {
  if (!candidate) {
    return "";
  }
  if (candidate.lead_id) {
    return String(candidate.lead_id);
  }
  const userUniqueId = candidate.user_unique_id;
  if (userUniqueId) {
    return String(userUniqueId).replace(/-/g, "");
  }
  return "";
}

